// @noflow
import BreedCard, { NonPopularBreed, PopularBreed } from './BreedCard'

export default BreedCard
export type { NonPopularBreed, PopularBreed }
